import { apiApplyPromo, apiGetPricingSummary } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setPricing } from "../../actionCreators/makeActionCreator";
export const LoadPricingThunk = () => async (dispatch) => {
    try {
        const data = await apiGetPricingSummary();
        if (data.banner_text !== null) {
            toastService.successMessage(data.banner_text, 8000);
        }
        const filteredPricing = data.lineItems.filter((item) => item.line_item_name !== "BlenderBottle" && item.line_item_name !== "Water Bottle");
        const pricing = {
            lineItems: filteredPricing,
            discount_str: data.discount_str,
            user_cart: data.user_cart,
            recurring_discount_str: data.recurring_discount_str,
            banner_text: data.banner_text,
            referral_data: data.referral_data,
        };
        dispatch(setPricing(pricing));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export const ApplyPromoThunk = (promo) => async (dispatch) => {
    try {
        const response = await apiApplyPromo({ promo });
        return response;
    }
    catch (e) {
        toastService.errorMessage(e);
    }
    return null;
};
